const { InnerBlocks } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { margin } = attributes;

  return (
    <div className={`Plans PlansCorporate ${margin}`}>
      <div className="Container Container-PME">
        <div className="Plans-wrap Plans-companing">
          <div className="swiperPlansCompaning">
            <div className="swiper-wrapper">
              <InnerBlocks.Content />
            </div>
          </div>

          <div className="Plans-wrapButtons wrapButtons-companing">
            <div class="Plans-antes"></div>
            <div class="Plans-depois"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Save;
